export const quizData = ({ quizEditorReducer: { quizQuestionsPanel } }) => quizQuestionsPanel;
export const selectedQuestionData = ({ quizEditorReducer: { selectedQuestion } }) =>
	selectedQuestion;
export const quizFullData = ({ quizEditorReducer }) => quizEditorReducer;
